module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.12.0.0.box.847.862.358.94.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.12.0.0.box.847.862.358.94.q.90"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.1.0.box.282.1501.1495.1452.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.12.1.0.box.282.1501.1490.316.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("decade")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("sixties")]), _c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  }), _vm._v(" began and ended with a bang. In 1961, four little black girls were integrated into the all-white public schools of New Orleans, and in 1963, the youngest president in our country's history was killed by an assassin's bullet on a sunny November morning in Dallas, Texas. At the end of the decade, in 1969, Neil Armstrong fulfilled President Kennedy's dream by stepping on the moon and declaring it a \"giant leap for mankind.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.1.box.283.1828.1494.424.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.1.0"
    }
  }), _vm._v("The decade of the sixties was one that confounded America like no period ever before. It was a tumultuous, threatening, liberating, bloody time which seemed about to change the world. It ushered in a storm of social change and enormous tension. It was a time of expansion of the suburbs and the reconstruction of Poydras Street with the Rivergate anchoring one end and the first signs of Superdome construction at the other. It was the time of the emergence of some of the biggest buildings in the city, of the super krewes, and of tourism as the city's major concern.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.2.box.284.2262.1488.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.2.0"
    }
  }), _vm._v("It was a decade when orchestras gave way to Rock & Roll groups, when dancing took the shape of the Twist and the Frugue, and when youth, women, and blacks all clamored for rights and acceptance.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.3.box.283.2425.1490.250.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.3.0"
    }
  }), _vm._v("Integration was happening everywhere, not only in schools, but in public places and city government. According to past mayor Moon Landrieu, \"New Orleans came out of the sixties pretty well. Though there were riots in other cities with large black populations like Watts, Detroit, and New York, there were none here.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.4.box.283.2694.1490.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.4.0"
    }
  }), _vm._v("It was not a Golden Age, but we weathered it well, and emerged the better for having defeated the Riverfr"), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.2.0.0"
    }
  }), _vm._v("ont Expressway, triumphed over the opponents of the Domed Stadium, obtained a franchise in the NFL, reinvented Poydras Street,"), _c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _vm._v(" connected with the West Bank and St. Tammany Parish, and expanded the suburbs. All in all, the sixties offered some giant leaps for New Orleans.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA12"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96af5232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0006.vue
// module id = 60
// module chunks = 0